import type { IconName } from "./Icon.js";

export interface NavItem {
  path: string;
  label: string;
  icon: IconName;
  /** Hidden when the AI module flag is off (doc 01 §1.8 cascade). */
  aiGated?: boolean;
}
export interface NavGroup {
  group: string;
  items: NavItem[];
}

/** Grouped nav (handoff README §Screens): Operate · Library · System. */
export const NAV: NavGroup[] = [
  {
    group: "Operate",
    items: [
      { path: "/", label: "Dashboard", icon: "dashboard" },
      { path: "/inbox", label: "Inbox", icon: "inbox" },
      { path: "/broadcasts", label: "Broadcasts", icon: "broadcast" },
      { path: "/campaigns", label: "Campaigns", icon: "campaign" },
    ],
  },
  {
    group: "Library",
    items: [
      { path: "/templates", label: "Templates", icon: "template" },
      { path: "/contacts", label: "Contacts", icon: "contacts" },
      { path: "/automations", label: "Automations", icon: "automation" },
    ],
  },
  {
    group: "System",
    items: [
      { path: "/ai-agent", label: "AI Agent", icon: "ai", aiGated: true },
      { path: "/settings", label: "Settings", icon: "settings" },
    ],
  },
];

export const ALL_NAV_ITEMS: NavItem[] = NAV.flatMap((g) => g.items);
